import { GetterTree } from 'vuex'
import { PushDevicesState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<PushDevicesState, RootState> = {
    pushDevices: state => state.pushDevices,
    pushOsVersions: state => state.pushOsVersions[0]?.versions,
    pushMappsVersions: state => state.pushMappsVersions[0]?.versions,
    pushSdkVersions: state => state.pushSdkVersions,
};
